import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkScheduleViewComponent } from './work-schedule-view/work-schedule-view.component';
import { LocaltimeScheduleViewComponent } from './localtime-schedule-view/localtime-schedule-view.component';
import { ObjectScheduleViewComponent } from './object-schedule-view/object-schedule-view.component';
import { GlobaltimeScheduleViewComponent } from './globaltime-schedule-view/globaltime-schedule-view.component';
// import {InsparkComponentsModule, TableComponentModule, TranslateModule} from '@inspark/inspark-components';
import {PageStandardFormsModule} from '../../../../src/app/page/shared/page-standard-forms/page-standard-forms.module';
import {SharedModule} from '../../../../src/app/shared/shared.module';

import { DateListEditComponent } from './date-list-edit/date-list-edit.component';
import { DateRepeatEditComponent } from './date-repeat-edit/date-repeat-edit.component';
import { WorkBindingtypeEditComponent } from './work-bindingtype-edit/work-bindingtype-edit.component';
import { DayBindingtypeEditComponent } from './day-bindingtype-edit/day-bindingtype-edit.component';
import {ScheduleTimelineComponent} from './timeline/schedule-timeline.component';
import {LocaleService} from '../../../../src/app/shared/services/locale.service';
import { TimeLabelFromMinutesPipe } from './time-label-from-minutes.pipe';
import { TimeBindingEditComponent } from './time-binding-edit/time-binding-edit.component';
import {InsparkInputNumberModule} from '../inspark-input-number/inspark-input-number.module';
import {DaysListEditComponent} from './days-list-edit/days-list-edit.component';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import {InsparkUIModule} from "../../../../src/app/inspark.module";
import {TranslateModule} from "@ngx-translate/core";
import { InDatePickerComponent } from '@inspark/inspark-components';

@NgModule({
  declarations: [
    ScheduleTimelineComponent,
    WorkScheduleViewComponent,
    LocaltimeScheduleViewComponent,
    ObjectScheduleViewComponent,
    GlobaltimeScheduleViewComponent,
    DateListEditComponent,
    DateRepeatEditComponent,
    WorkBindingtypeEditComponent,
    DayBindingtypeEditComponent,
    TimeLabelFromMinutesPipe,
    TimeBindingEditComponent,
    DaysListEditComponent,
  ],
  providers: [LocaleService],
  imports: [
    CommonModule,
    InsparkUIModule,
    PageStandardFormsModule,
    TranslateModule,
    SharedModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    InsparkInputNumberModule,
    InDatePickerComponent,
  ],
  exports: [
    WorkScheduleViewComponent,
    LocaltimeScheduleViewComponent,
    ObjectScheduleViewComponent,
    GlobaltimeScheduleViewComponent,
  ],
})
export class InsparkScheduleTamplateModule {}
